const transitions = {
  cubicBezier8: 'all 0.8s cubic-bezier(0, 0, 0.2, 1)'
}

export default transitions
